var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { ToolbarWithBackButton, ToolbarWithOnClick } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, TileComment, TileHeader, GridHeader, Tile, } from '../common/Tile';
import { ContentBox, ContentImage } from './ContentCommon';
import { EllipsisManyLines } from '../common/typography';
import { EllipsisOneLine, EllipsisThreeLines, } from '@bootstraplabs/bsw-common-react';
import { useRouter } from '../../context/router-context';
import Loading from '../common/Loading';
import { useViewer } from '../../context/viewer-context';
import CreateContentModal from './CreateContentModal';
import { useContentListQuery, UserRole } from '../../__generated__/graphql';
function Toolbar(props) {
    return (_jsx(ToolbarWithOnClick, __assign({ onClick: props.onClick, "data-test": "content-home-toolbar" }, { children: "Content" }), void 0));
}
function Toolbar2() {
    return _jsx(ToolbarWithBackButton, { children: "Content" }, void 0);
}
function labelFilterPredicate(l) {
    return function (c) { return c.label === l; };
}
export default function ContentHome() {
    // Router
    var goForwardClick = useRouter().goForwardClick;
    var _a = useContentListQuery(), data = _a.data, loading = _a.loading;
    var contents = (data && data.contents) || [];
    // Context
    var _b = useViewer(), hasRole = _b.hasRole, viewer = _b.viewer;
    var canPost = hasRole(UserRole.THOUGHT_LEADERSHIP__POST);
    // State - modal
    var _c = useState(false), modalIsOpen = _c[0], setModalIsOpen = _c[1];
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    var labels = Array.from(new Set(contents.map(function (c) { return c.label; })));
    if (!viewer) {
        throw new Error('unauthorized');
    }
    return (_jsxs(_Fragment, { children: [canPost ? (_jsx(Toolbar, { onClick: function () { return setModalIsOpen(true); } }, void 0)) : (_jsx(Toolbar2, {}, void 0)),
            _jsx(CreateContentModal, { open: modalIsOpen, onCancel: function () { return setModalIsOpen(false); } }, void 0),
            _jsx(Body, { children: labels.map(function (label) { return (_jsxs(Fragment, { children: [_jsx(GridHeader, { children: label }, void 0),
                        _jsx(Grid, { children: contents.filter(labelFilterPredicate(label)).map(function (c) { return (_jsx(Tile, __assign({ onClick: goForwardClick(c.id) }, { children: c.type === 'VIDEO' ? (_jsxs(_Fragment, { children: [_jsx(TileHeader, { children: _jsx(EllipsisOneLine, { children: c.title }, void 0) }, void 0),
                                        _jsx(ContentBox, { children: _jsx(ContentImage, { src: c.imageUrl ||
                                                    'https://i.vimeocdn.com/video/828962658_640.jpg' }, void 0) }, void 0),
                                        _jsx(TileComment, { children: _jsx(EllipsisThreeLines, { children: c.description }, void 0) }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx(TileHeader, { children: _jsx(EllipsisOneLine, { children: c.title }, void 0) }, void 0),
                                        _jsx(ContentBox, { children: _jsx(TileComment, { children: _jsx(EllipsisManyLines, { children: c.description }, void 0) }, void 0) }, void 0)] }, void 0)) }), c.id)); }) }, void 0)] }, label)); }) }, void 0)] }, void 0));
}
//# sourceMappingURL=ContentHome.js.map